export const SAVE_PROFILE = "SAVE_PROFILE";
export const LOAD_PROFILES = "LOAD_PROFILES";
export const LOAD_PROFILE = "LOAD_PROFILE";
export const DELETE_PROFILE = "DELETE_PROFILE";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const SELECT_PROFILE = "SELECT_PROFILE";
